// src/components/Notification.tsx
import React from 'react';
import { Alert } from 'react-bootstrap';

interface NotificationProps {
  type: 'success' | 'error'; // Define el tipo de notificación
  message: string;
  onClose: () => void;
}

const Notification: React.FC<NotificationProps> = ({ type, message, onClose }) => {
  const variant = type === 'success' ? 'success' : 'danger'; // Bootstrap variantes
  return (
    <Alert variant={variant} onClose={onClose} dismissible>
      {message}
    </Alert>
  );
};

export default Notification;